var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { ContextMenuAFY, icons, sizesIcon, } from "@affinitysystemsgroup/github-packages-affinity-components/dist";
import { ACTION_DELETE, ACTION_EDIT } from "./planCreation.constants";
var MENU_ICON_COLOR = "#006ac6";
var ROW_ACTIONS_MENU = [
    {
        disabled: false,
        icon: {
            color: MENU_ICON_COLOR,
            icon: icons.Edit,
            size: sizesIcon.standard,
        },
        id: ACTION_EDIT,
        name: "Editar",
    },
    {
        disabled: false,
        icon: {
            color: MENU_ICON_COLOR,
            icon: icons.DeleteForever,
            size: sizesIcon.standard,
        },
        id: ACTION_DELETE,
        name: "Eliminar",
    },
];
var CONTEXT_MENU_PROPS = {
    colorButton: "#fff",
    iconButton: icons.MoreVert,
    iconColor: "#3A56A1",
    sizeIcon: sizesIcon.standard,
    menuItem: ROW_ACTIONS_MENU,
};
var buildActionsColumn = function (width, onAction, flex) { return (__assign(__assign({ field: "type", headerName: "Acciones", width: width }, (flex ? { flex: flex } : {})), { renderCell: function (params) { return (_jsx("div", __assign({ style: { display: "flex", gap: "10px" } }, { children: _jsx(ContextMenuAFY, __assign({}, CONTEXT_MENU_PROPS, { onClickContextMenu: function (item) {
                return onAction(item, params.row);
            } })) }))); } })); };
export var buildBenefitsColumns = function (onAction) { return [
    buildActionsColumn(100, onAction),
    { field: "description", headerName: "Descripción", flex: 1, width: 150 },
    { field: "value", headerName: "Valor", flex: 1, width: 150 },
]; };
export var buildPrimesColumns = function (onAction) { return [
    buildActionsColumn(150, onAction, 1),
    { field: "minAge", headerName: "Edad mínima", flex: 1, width: 150 },
    { field: "maxAge", headerName: "Edad máxima", flex: 1, width: 150 },
    { field: "paymentMode", headerName: "Periodicidad", flex: 1, width: 150 },
    { field: "coverType", headerName: "Tipo de cobertura", flex: 1, width: 150 },
    { field: "price", headerName: "Prima", flex: 1, width: 150 },
]; };
